import {FC} from "react";
import {useSelector} from "react-redux";
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {getPatientSteps} from "../../../../../../redux/selectors/patientsSelector";
import {IStep} from "../../../../../../utils/interfaces";
import {format, parse} from "date-fns";

const formatSteps = (steps: IStep[]) => {
  return steps.map(step => ({
    ...step,
    date: format(parse(step.date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
  }))
}

export const StepsGraph: FC = () => {
  const stepsData = useSelector(getPatientSteps)

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        style={{width: '100%', maxHeight: '450px'}}
        data={Array.isArray(stepsData) ? formatSteps(stepsData) : []}
        margin={{
          top: 5,
          right: 0,
          left: 0,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis yAxisId="left" dataKey="steps" />
        <YAxis yAxisId="right" orientation="right" dataKey="distance" tickFormatter={(value) => `${value} km`}  />
        <Tooltip formatter={(value, name) => name === 'distance' ? `${value} km` : value} />
        <Bar yAxisId="left" dataKey="steps" fill="#7897FF" radius={[4, 4, 0, 0]} />
        <Bar yAxisId="right" dataKey="distance" fill="#032596" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
